/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Booking_Duration_Limits_HintInputs */

const en_admin_resource_form_booking_duration_limits_hint = /** @type {(inputs: Admin_Resource_Form_Booking_Duration_Limits_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The shortest and longest booking allowed for this resource`)
};

const de_admin_resource_form_booking_duration_limits_hint = /** @type {(inputs: Admin_Resource_Form_Booking_Duration_Limits_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die kürzeste und längste Buchung, die für diese Ressource erlaubt ist`)
};

const es_admin_resource_form_booking_duration_limits_hint = /** @type {(inputs: Admin_Resource_Form_Booking_Duration_Limits_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La reserva más corta y más larga permitida para este recurso`)
};

const fr_admin_resource_form_booking_duration_limits_hint = /** @type {(inputs: Admin_Resource_Form_Booking_Duration_Limits_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La réservation la plus courte et la plus longue autorisée pour cette ressource`)
};

const nl_admin_resource_form_booking_duration_limits_hint = /** @type {(inputs: Admin_Resource_Form_Booking_Duration_Limits_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De kortste en langste reservering die voor deze voorziening is toegestaan`)
};

/** @type {(inputs: Admin_Resource_Form_Booking_Duration_Limits_HintInputs) => LocalizedString} */
const it_admin_resource_form_booking_duration_limits_hint = en_admin_resource_form_booking_duration_limits_hint;

/** @type {(inputs: Admin_Resource_Form_Booking_Duration_Limits_HintInputs) => LocalizedString} */
const pt_br2_admin_resource_form_booking_duration_limits_hint = en_admin_resource_form_booking_duration_limits_hint;

/** @type {(inputs: Admin_Resource_Form_Booking_Duration_Limits_HintInputs) => LocalizedString} */
const pl_admin_resource_form_booking_duration_limits_hint = en_admin_resource_form_booking_duration_limits_hint;

/** @type {(inputs: Admin_Resource_Form_Booking_Duration_Limits_HintInputs) => LocalizedString} */
const hu_admin_resource_form_booking_duration_limits_hint = en_admin_resource_form_booking_duration_limits_hint;

/** @type {(inputs: Admin_Resource_Form_Booking_Duration_Limits_HintInputs) => LocalizedString} */
const ro_admin_resource_form_booking_duration_limits_hint = en_admin_resource_form_booking_duration_limits_hint;

/**
* | output |
* | --- |
* | "The shortest and longest booking allowed for this resource" |
*
* @param {Admin_Resource_Form_Booking_Duration_Limits_HintInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_booking_duration_limits_hint = /** @type {((inputs?: Admin_Resource_Form_Booking_Duration_Limits_HintInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Booking_Duration_Limits_HintInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_booking_duration_limits_hint(inputs)
	if (locale === "de") return de_admin_resource_form_booking_duration_limits_hint(inputs)
	if (locale === "es") return es_admin_resource_form_booking_duration_limits_hint(inputs)
	if (locale === "fr") return fr_admin_resource_form_booking_duration_limits_hint(inputs)
	if (locale === "nl") return nl_admin_resource_form_booking_duration_limits_hint(inputs)
	if (locale === "it") return it_admin_resource_form_booking_duration_limits_hint(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_booking_duration_limits_hint(inputs)
	if (locale === "pl") return pl_admin_resource_form_booking_duration_limits_hint(inputs)
	if (locale === "hu") return hu_admin_resource_form_booking_duration_limits_hint(inputs)
	return ro_admin_resource_form_booking_duration_limits_hint(inputs)
});
export { admin_resource_form_booking_duration_limits_hint as "admin.resource_form.booking_duration_limits_hint" }